var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"page-title-box d-md-flex justify-content-between"},[_c('div',[_c('h3',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.t("Refer Broker")))])])])])]),_c('p',[_vm._v(_vm._s(_vm.t("Share your link to refer brokers to your network.")))]),_c('ReferralLink')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }